import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "../../assets/styles/dashboard.css";

const DashboardContainer: React.FC = () => {
  return (
    <div className="dashboard-container">
      {/* Only render the main content area, remove header and nav */}
      <div className="dashboard-content">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardContainer;
